import { type IErrorResponse, ErrorLevel } from '../models/error-response.model';

export class ErrorResponseHelper {
  static enrichApiPlaneraResaErrorResponse(error: IErrorResponse, translationFunc: (translationId: string) => string): IErrorResponse {
    const enrichedError: IErrorResponse = { ...error };

    switch (error.statusCode) {
      case 503:
        enrichedError.errorLevel = ErrorLevel.error;
        enrichedError.errorMessage = translationFunc('common.aprerror503');
        return enrichedError;
      case 401:
      case 500:
        enrichedError.errorLevel = ErrorLevel.error;
        enrichedError.errorMessage = translationFunc('common.generalerror');
        return enrichedError;
      default:
        break;
    }

    if (error.statusCode === 400) {
      switch (error.errorCode) {
        case 2020:
          enrichedError.errorLevel = ErrorLevel.error;
          enrichedError.errorMessage = translationFunc('common.aprerror2020');
          break;
        default:
          enrichedError.errorLevel = ErrorLevel.information;
          enrichedError.errorMessage = translationFunc('triplegselector.searcherrornotrips');
          break;
      }
    }

    return enrichedError;
  }
}
